module.exports = __webpack_public_path__ + "media/images/lb/313-1bdbf6f251ddabeea2b79c54622e9e17.svg";